/**
 *
 * action buttons 14691(BC Vozdvizhenka)
 *
 */

import React from "react";

import Done from "@material-ui/icons/Done";
import FileCopy from '@material-ui/icons/FileCopy';
import {requestAction} from "domain/typeConstants/action";
import {requestStatus} from "domain/typeConstants/status";
import {getValueFromLocalStorage} from "utils/localStorage";
import {GLOBAL_USER_KEY} from "global-constants";
import {ON_CAR_ENTRY, ON_PROPERTY_BRINGING, ON_PROPERTY_REMOVAL, ON_VISIT} from 'domain/Data/RequestType/constants';
import Clear from "@material-ui/icons/Clear";
import CallReceived from "@material-ui/icons/CallReceived";


export const acceptActionButtonReception = {
    name: requestAction.ACCEPT,
    label: 'Принять',
    icon: 'done',
    svgIcon: <Done/>,
    disabled: (selection, entities) => {
        if (selection.length !== 0) {
            if (!entities[0].status) return false;
            if (selection.find(element => element.type.id === ON_PROPERTY_BRINGING || element.type.id === ON_PROPERTY_REMOVAL)) return true
            if (!entities[0].agreedEmployee) return false;
            return entities.some((element) => element.status &&
                (element.status.name === requestStatus.CLOSED || element.status.name === requestStatus.COMPLETED ||
                    element.status.name === requestStatus.ACCEPTED || element.status.name === requestStatus.IN_PROGRESS
                    || element.status.name === requestStatus.AGREED)
                || (element.status.name === requestStatus.REJECTED
                    && element.agreedEmployee.id !== getValueFromLocalStorage(GLOBAL_USER_KEY).id)
            );
        }
        return true;
    },
};

const rejectActionDisableStatuses = [requestStatus.CLOSED, requestStatus.COMPLETED, requestStatus.REJECTED, requestStatus.AGREED]

export const rejectActionButtonReception = {
    name: requestAction.REJECT,
    label: 'Отклонить',
    icon: 'clear',
    svgIcon: <Clear/>,
    disabled: (selection, entities, currentRecord) => {
        if (currentRecord && selection.length === 0) {
            if (!currentRecord.status) return false
            return rejectActionDisableStatuses.includes(currentRecord.status.name)
        } else if (selection.length > 0) {
            if (selection.find(element => element.type.id === ON_PROPERTY_BRINGING || element.type.id === ON_PROPERTY_REMOVAL)) return true
            return entities.some((element) => element.status &&
                rejectActionDisableStatuses.includes(element.status.name)
            );
        } else return true
    },
};

export const acceptActionButton = {
    name: requestAction.ACCEPT,
    label: 'Принять',
    icon: 'done',
    svgIcon: <Done/>,
    disabled: (selection, entities) => {
        if (selection.length !== 0) {
            if (!entities[0].status) return false;
            if (!entities[0].agreedEmployee) return false;
            return entities.some((element) => element.status &&
                (element.status.name === requestStatus.CLOSED || element.status.name === requestStatus.COMPLETED ||
                    element.status.name === requestStatus.ACCEPTED || element.status.name === requestStatus.IN_PROGRESS
                    || element.status.name === requestStatus.AGREED)
                || (element.status.name === requestStatus.REJECTED
                    && element.agreedEmployee.id !== getValueFromLocalStorage(GLOBAL_USER_KEY).id));
        }
        return true;
    },
};

export const copyActionButton = {
    name: requestAction.COPY,
    label: 'Копия',
    icon: 'content_copy',
    svgIcon: <FileCopy/>,
    disabled: (selection, entities) => {
        return selection.length !== 1 || isCarEntryRequest(entities)
    },
};

const isCarEntryRequest = (entities) => {
    const requestTypeId = entities[0] && entities[0].type && entities[0].type.id ? entities[0].type.id : null
    return requestTypeId === ON_CAR_ENTRY
}

export const personalDataActionButton = {
    name: requestAction.PERSONAL_DATA,
    label: 'Персональные Данные',
    icon: 'fingerprint',
    disabled: (selection, entities, currentRecord) => {
        if (!currentRecord) return true;
        return currentRecord && currentRecord?.type?.id !== ON_VISIT
    },
};

const arrivedActionDisableStatuses = [requestStatus.CLOSED, requestStatus.COMPLETED, requestStatus.IN_PROGRESS]
export const arrivedActionButton = {
    name: requestAction.ARRIVED_WITH_PD,
    label: 'Прибыл',
    icon: 'call_received',
    svgIcon: <CallReceived />,
    disabled: (selection, entities, currentRecord) => {
            if (selection.length === 1) {
            if (!entities[0].status) return false;
            return arrivedActionDisableStatuses.includes(entities[0].status.name)
        }
        return true;
    },
};